module.exports = __webpack_public_path__ + "static/media/rhombus-dark.5a593182.svg";